import selectPurchasePrice from './select-purchase-price';
import {createSelector} from '@reduxjs/toolkit';

export default (coe: number) =>
  createSelector([selectPurchasePrice], purchasePrice => {
    return coe * purchasePrice;
  });
